import React, { useState, useEffect } from "react";

import { database } from "../../firebaseConfig";
import { ref, get, set } from "firebase/database";



const ProductDescriptionConfigEditor = () => {
    const [config, setConfig] = useState({
        buy_now: { visible: false },
        add_cart: { visible: false },
        enquire: { visible: false, token: "" },
    });
    const [loading, setLoading] = useState(true);

    // Fetch existing config on load
    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const snapshot = await get(ref(database, "product_discription"));
                const fetchedConfig = snapshot.exists() ? snapshot.val() : {};
                setConfig(prev => ({ ...prev, ...fetchedConfig }));
            } catch (error) {
                console.error("Error fetching config:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    // Fetch token if enquire is enabled
    const handleToggleEnquire = async (e) => {
        const isChecked = e.target.checked;
        let token = config.enquire.token;

        if (isChecked) {
            try {
                const fetchedConfiginq = await get(ref(database, "floatingIconsConfig"));
                const response = fetchedConfiginq.exists() ? fetchedConfiginq.val() : {};
                const inquireConfig = response?.inquire;

                if (inquireConfig?.formToken) {
                    token = inquireConfig.formToken;
                }
            } catch (error) {
                console.error("Error fetching floatingIconsConfig:", error);
                alert("Failed to fetch enquire token.");
            }
        }

        setConfig((prev) => ({
            ...prev,
            enquire: {
                visible: isChecked,
                token,
            },
        }));
    };


    const handleSaveConfig = async () => {
        try {
            await set(ref(database, "product_discription"), config);
            alert("Configuration saved successfully!");
        } catch (error) {
            console.error("Error saving config:", error);
            alert("Failed to save configuration.");
        }
    };

    if (loading) return <div>Loading configuration...</div>;

    return (
        <div>
            <h2>Product Description Config Editor</h2>

            <label>
                <input
                    type="checkbox"
                    checked={config.buy_now.visible}
                    onChange={(e) =>
                        setConfig((prev) => ({
                            ...prev,
                            buy_now: { visible: e.target.checked },
                        }))
                    }
                />
                Enable Buy Now Button
            </label>
            <br />

            <label>
                <input
                    type="checkbox"
                    checked={config.add_cart.visible}
                    onChange={(e) =>
                        setConfig((prev) => ({
                            ...prev,
                            add_cart: { visible: e.target.checked },
                        }))
                    }
                />
                Enable Add to Cart Button
            </label>
            <br />

            <label>
                <input
                    type="checkbox"
                    checked={config.enquire.visible}
                    onChange={handleToggleEnquire}
                />
                Enable Enquire Button
            </label>
            <br />

            {config.enquire.visible && (
                <div>
                    <strong>Token:</strong> {config.enquire.token}
                </div>
            )}

            <br />
            <button onClick={handleSaveConfig}>Save Configuration</button>
        </div>
    );
};

export default ProductDescriptionConfigEditor;
